var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOkContour = function SvgOkContour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-407.000000, -1593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(407.000000, 1593.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3598156,6.23177872 C14.7840925,5.87821464 15.4146572,5.9355387 15.7682213,6.3598156 C16.1217854,6.7840925 16.0644613,7.4146572 15.6401844,7.76822128 L9.6401844,12.7682213 C9.26933845,13.0772596 8.73066155,13.0772596 8.3598156,12.7682213 L5.3598156,10.2682213 C4.9355387,9.9146572 4.87821464,9.2840925 5.23177872,8.8598156 C5.5853428,8.4355387 6.2159075,8.37821464 6.6401844,8.73177872 L9,10.6982917 L14.3598156,6.23177872 Z"
  }))))));
};
export default SvgOkContour;